import useSettings from './Settings'
import { PARTNER_PACKAGES } from '../helpers/subscriptionHelpers/moduleDefinitions'
import calculateTotal from '../helpers/subscriptionHelpers/calculateTotal'

const useSubscriptionPricing = () => {

    const subscription = useSettings().subscription

    const modules = subscription?.modules || {}
    const partnerSlug = subscription?.partner || null
    const partner = partnerSlug ? (PARTNER_PACKAGES[partnerSlug] || null) : null

    const activeModules = Object.keys(modules).filter((slug) => modules[slug] === true)
    const monthlyTotal = calculateTotal({ activeModules: modules, partner })

    return {
        activeModules,
        monthlyTotal,
        partner,
        status: subscription?.status || null,
        billingType: subscription?.billingType || null,
    }

}

export default useSubscriptionPricing
